import { Entity } from '../entity';
import { IForm } from './base.form';

export interface FormField extends IForm {
    options: any;
    readonly: boolean;
    color?: string;
}

export enum FormFieldPrintVisibility {
    Visible = 'Visible',
    Hidden = 'Hidden',
    HiddenIfEmpty = 'Hidden If Empty'
}

export enum FormFieldSubmitAction {
    None = 'None',
    Overwrite = 'Set Value (Overwrite)',
    Append = 'Set Value (Append)',
}

export interface FormFieldSubmitOptions {
    action: FormFieldSubmitAction;
    value: string;
    field?: any;
    format?: FormFieldSubmitFormat;
}

export enum FormFieldSubmitFormat {
    Value = 'Value',
    QuestionAndValue = 'Question and Value',
}